import { configuration } from '../configuration';
import { ExternalUserForm } from '../models/administration';

export const getInternalUsersUrl = (projectCode: string, startWith = ''): string =>
    `${configuration.user_permissions_endpoint}/ManageDomainUser/ListAllDomainUser?projectCode=${encodeURIComponent(projectCode)}&startWith=${encodeURIComponent(startWith)}&top=${startWith ? 20 : 0}`;

export const getExternalUsersUrl = (projectCode: string, startWith = ''): string =>
    `${configuration.user_permissions_endpoint}/ManageExternalUser/ListAllExternalUser?projectCode=${encodeURIComponent(projectCode)}&startWith=${encodeURIComponent(startWith)}&top=${startWith ? 20 : 0}`;

export const newExternalUserUrl = (form: ExternalUserForm): string =>
    `${configuration.user_permissions_endpoint}/ManageExternalUser/CreateExternalUser?email=${encodeURIComponent(form.email)}&company=${encodeURIComponent(form.company)}&country=${encodeURIComponent(form.country)}`;

export const dowloadUsersUrl = (): string => `${configuration.user_permissions_endpoint}/ManageDomainUser/DownloadAllUserReport`;